import { useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { usePreguntasMaterias } from "../../hooks/adminexamen/usePreguntasMaterias";
import { elToast } from "../../functions/alertas";
import { URL_BACKEND } from "../../api/url";
import {
  indicesPreguntasMateriaStore,
  indicesPreguntasContestadasStore,
} from "../../stores/preguntasContestadasStore";



const useResponderExamen = () => {

    const navigator = useNavigate();

    const { id } = useParams(); //id de la materia del examen en que se ha ingresado

    const cookies = new Cookies();

    const fk_aspirante = cookies.get("pk_aspirante");
    const fk_carrera = cookies.get("fk_carrera");

    //VALIDAR CUÁLES EXÁMENES MOSTRAR AL ASPIRANTE DEPENDIENDO SU CARRERA

    const carrerasEIMC = ["1", "2", "4", "5", "6", "7"]; //carreras que tienen EOYE, Inglés y MC
    //las carreras 3 y 8 tienen EOYE, Inglés y MEA

    // eslint-disable-next-line


    if ( carrerasEIMC.includes(fk_carrera) ) {

        var materiasExamen = ["1", "2", "4"]; //1: EOYE, 2: MC, 4: Inglés

    } else {

        var materiasExamen = ["1", "3", "4", "5"]; //1: EOYE, 2: MEA, 4: Inglés

    }




    const vaciarIndicesPreguntasContestadas = indicesPreguntasContestadasStore(state => state.vaciarArreglo);

    const totalIndicesPreguntasContestadas = indicesPreguntasContestadasStore(state => state.indicesPreguntasContestadas);


    const vaciarIndicesPreguntasMaterias = indicesPreguntasMateriaStore(state => state.vaciarArreglo);

    const agregarIndices = indicesPreguntasMateriaStore(state => state.agregarIndices);

    const totalIndicesPreguntasMateria = indicesPreguntasMateriaStore(state => state.indicesPreguntasMateria);




    //título de la materia de examen
    var nombreMateria = "";

    var indicesPreguntasMateria = []; //arreglo con el total de indices de preguntas dependiendo la materia


    if (id == "1")
    {
        nombreMateria = "Expresión Oral y Escrita";

        for (var i = 1; i <= 89; i++) {
          indicesPreguntasMateria.push(i);
        }

    }
    else if (id == "2")
    {
        nombreMateria = "Matemáticas Ciencias";

        for (var i = 1; i <= 50; i++) {
            indicesPreguntasMateria.push(i);
        }

    }
    else if (id == "3")
    {
        nombreMateria = "Matemáticas EA";

        for (var i = 1; i <= 50; i++) {
            indicesPreguntasMateria.push(i);
        }

    }
    else if (id == "4")
    {
      nombreMateria = "Inglés";

      for (var i = 1; i <= 55; i++) {
        indicesPreguntasMateria.push(i);
      }

    }
    else
    {
        nombreMateria = "Examen";
    }



    const cuentaRegresivaTerminada = () => {

        alert("El tiempo para responder la materia ha terminado.\nSerás dirigido al menú principal.");

        navigator("/examen/");
        return;

    }


    const verificarTerminarExamen = () => {

        //verificar si se contestaron todas las preguntas del examen

        let preguntasNoContestadas = totalIndicesPreguntasMateria[0].filter((indicePreguntaMateria) => {

            if (totalIndicesPreguntasContestadas.includes(indicePreguntaMateria) == false) {
                return true;
            }

        })

        if (preguntasNoContestadas.length > 0) { //hay preguntas no contestadas

            var todosMensajesPorPregunta = "";

            preguntasNoContestadas.forEach(pregunta => {

                let mensajePorPregunta = "\n● Pregunta " + pregunta;

                todosMensajesPorPregunta += mensajePorPregunta;
            });

            let mensaje = "❕ Aun tienes preguntas sin responder:" + todosMensajesPorPregunta;

            elToast(mensaje, 'nada');

        } else {

            //confirmar si el usuario quiere salir del examen

            if (window.confirm("¿Estás seguro de querer terminar?\nSi finalizas esta materia no podrás volver a entrar después."))
            {

                //actualizar estado del examen a 1 (finalizado) y registrar la fecha en la que se terminó

                let formData = new FormData();
                formData.append("funcion", "actualizarEstadoExamen");
                formData.append("fk_aspirante", fk_aspirante);
                formData.append("fk_materia", id);

                fetch(URL_BACKEND, {
                    method: "POST",
                    body: formData,
                })
                .then((res) => res.json())
                .then((r) => {

                    if (r.codigo == 1) { //proceso exitóso

                        navigator("/examen/");
                        return;

                    } else {

                        elToast('Ocurrió un problema al finalizar la materia, vuelve a intentarlo.', "error");

                    }

                })
                .catch( () => { elToast('Ocurrió un problema al finalizar la materia, vuelve a intentarlo.', "error"); } )

            }

        }

    }

    const { preguntasDeMateria } = usePreguntasMaterias()


    // hola :D esta validación es para que no se salgan sisi
    var areYouReallySure = false;
    function areYouSure() {
        if(allowPrompt){
            if (!areYouReallySure && true) {
                areYouReallySure = true;
                var confMessage = "";
                return confMessage;
            }
        }else{
            allowPrompt = true;
        }
    }
    var allowPrompt = true;
    window.onbeforeunload = areYouSure;




    useEffect(() => {

        //validar que el aspirante no pueda entrar a los exámenes que no le correspondan
        // eslint-disable-next-line
        if (materiasExamen.includes(id) == false) {

            console.log("No puede entrar a los exámenes que no le correspondan");
            navigator("/examen/");
            return;

        } else {

            //validar si se recargó la página para no volver a dejar entrar al aspirante
            let data = new FormData();
            data.append("funcion", "traerEstadoExamen");
            data.append("fk_aspirante", fk_aspirante);
            data.append("fk_materia", id);

            fetch(URL_BACKEND, {
                method: "POST",
                body: data,
            })
            .then((res) => res.json())
            .then((r) => {

                if (r.codigo == 1) {

                    elToast("Ya has entrado y contestado este examen previamente, el acceso ha terminado.", "info3");

                    navigator("/examen/");
                    return;


                } else {

                    //es la primera vez que el usuario entra al examen

                    // generar registro de estado examen en 0 (pendiente)
                    let formData = new FormData();
                    formData.append("funcion", "guardarEstadoExamen");
                    formData.append("fk_aspirante", fk_aspirante);
                    formData.append("fk_materia", id);

                    fetch(URL_BACKEND, {
                        method: "POST",
                        body: formData,
                    })
                    .then((res) => res.json())
                    .then((r) => {

                        if(r.codigo == 0) {
                            //ocurrio un error
                            elToast("Ocurrió un problema al acceder a la materia, vuelve a intentarlo.", "error");

                            navigator("/examen/");
                            return;

                        } else {

                            //limpiar los arreglos de los indices para ser reutilizados en la nueva materia

                            vaciarIndicesPreguntasContestadas();

                            vaciarIndicesPreguntasMaterias();

                            //agregar al Store todos los indices de las preguntas de la materia
                            agregarIndices(indicesPreguntasMateria);


                            //guardar el id de la materia para validar su estado al salir de esta
                            localStorage.setItem("materiaContestada", id);


                            // guardar registro en la tabla de aplicación
                            let formData = new FormData();
                            formData.append("funcion", "guardarAplicacionAspirante");
                            formData.append("fk_aspirante", fk_aspirante);

                            fetch(URL_BACKEND, {
                                method: "POST",
                                body: formData,
                            })
                            .then((res) => res.json())
                            .then((r) => {

                                console.log(r);

                            })
                            .catch(() => { console.log("Ocurrió un problema al verificar la aplicación del examen.") });
                        }

                    })
                    .catch(() => { elToast('Ocurrió un problema al acceder a la materia, vuelve a intentarlo.', "error"); });
                }

            })
            .catch(() => { elToast('Ocurrió un problema al verificar la fecha de ingreso a esta materia, vuelve a intentarlo.', "error"); });

        // eslint-disable-next-line
        }
    }, [])





    return {
        nombreMateria,
        preguntasDeMateria,
        cuentaRegresivaTerminada,
        verificarTerminarExamen
    }


}

export default useResponderExamen;